function convertData(date) {
  let newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000)
  let offset = date.getTimezoneOffset() / 60
  let hours = date.getHours()
  newDate.setHours(hours - offset)
  return newDate
}
let day = 1000 * 60 * 60 * 24
let minute = 36e5 / 60
let second = minute / 60
function floor(value, threshold = 0) {
  let val = value > threshold ? Math.floor(value) : value
  return val
}
function calcDate(dateI = '') {
  let today = new Date()
  let date = convertData(new Date(dateI.replace(' ', 'T')))
  let diff = Math.floor(today.getTime() - date.getTime())
  // diff = (diff < 1) ? -diff : diff
  let hours = Math.floor(diff / 36e5)
  let message = ''
  if (hours <= 24) {
    if (hours < 1) {
      let minutes = Math.floor(diff / minute)
      let seconds = Math.floor(diff / second)
      message =
        minutes < 1
          ? `${seconds > 1 ? `${floor(seconds)} giầy` : 'vài giây'}`
          : `${minutes} phút`
    } else {
      hours = Math.floor(hours)
      message = `${hours} giờ`
    }
  } else {
    let days = Math.floor(diff / day)
    if (days <= 31) {
      message = `${days} ngày`
    } else {
      let months = Math.floor(days / 31)
      if (months <= 24) {
        message = `${months} tháng`
      } else {
        return dateI.split(' ')[0]
      }
    }
  }

  message += ' trước'

  return message
}
export default { calcDate }
